/**
 * 危废模块子路由
 * 路径均为相对路径，根路由会以 /waste 为前缀挂载
 */

// 危废子路由数组
export const wasteRoutes = [
  // 库存
  {
    path: 'inventory',
    name: 'WasteInventory',
    component: () => import('@/modules/waste/views/homeNav/inventory.vue')
  },
  // 产生
  {
    path: 'production',
    name: 'WasteProduction',
    component: () => import('@/modules/waste/views/homeNav/production.vue')
  },
  // 入库
  {
    path: 'inbound',
    name: 'WasteInbound',
    component: () => import('@/modules/waste/views/homeNav/inbound.vue')
  },
  // 出库
  {
    path: 'outbound',
    name: 'WasteOutbound',
    component: () => import('@/modules/waste/views/homeNav/outbound.vue')
  },
  // 处置（自行利用）
  {
    path: 'disposal',
    name: 'WasteDisposal',
    component: () => import('@/modules/waste/views/homeNav/selfuse.vue')
  },
  // 联单
  {
    path: 'kupono',
    name: 'WasteKupono',
    redirect: '/waste/kupono/transfer',
    component: () => import('@/modules/waste/views/homeNav/kupono/index.vue'),
    children: [
      { path: 'transfer', component: () => import('@/modules/waste/views/homeNav/kupono/Transfer.vue') },
      { path: 'return', component: () => import('@/modules/waste/views/homeNav/kupono/Return.vue') },
      { path: 'collect', component: () => import('@/modules/waste/views/homeNav/kupono/Collect.vue') },
      { path: 'cross', component: () => import('@/modules/waste/views/homeNav/kupono/Cross.vue') },
      { path: 'approve', component: () => import('@/modules/waste/views/homeNav/kupono/Approve.vue') },
      { path: 'inbound', component: () => import('@/modules/waste/views/homeNav/kupono/ApproveInbound.vue') }
    ]
  },
  // 台账
  {
    path: 'account',
    name: 'WasteAccount',
    component: () => import('@/modules/waste/views/homeNav/account.vue')
  },
  // 虚拟标签
  {
    path: 'virtual-tag',
    name: 'WasteVirtualTag',
    component: () => import('@/modules/waste/views/homeNav/virtualTag.vue')
  },
  // 物联网
  {
    path: 'internet',
    name: 'WasteInternet',
    component: () => import('@/modules/waste/views/iot/index.vue'),
    meta: { title: '物联网', theme: 'dark' }
  },
  // 个人中心
  {
    path: 'profile',
    name: 'WasteProfile',
    redirect: '/waste/profile/basic',
    component: () => import('@/modules/waste/views/homeNav/personal.vue'),
    children: [
      // 基本信息（默认页）
      {
        path: 'basic',
        name: 'WasteProfileBasic',
        component: () => import('@/modules/waste/views/homeNav/my/BasicInfo.vue')
      },
      // 单位信息
      {
        path: 'unit',
        name: 'WasteProfileUnit',
        component: () => import('@/modules/waste/views/homeNav/my/UnitInfo.vue')
      },
      // 业务信息
      {
        path: 'business',
        name: 'WasteProfileBusiness',
        component: () => import('@/modules/waste/views/homeNav/my/BusinessInfo.vue')
      },
      // 经办人管理
      {
        path: 'agent',
        name: 'WasteProfileAgent',
        component: () => import('@/modules/waste/views/homeNav/my/AgentManage.vue')
      },
      // 物联网设备管理
      {
        path: 'iot',
        name: 'WasteProfileIot',
        component: () => import('@/modules/waste/views/homeNav/my/IotManage.vue')
      },
      // 危废标签状态管理
      {
        path: 'label-status',
        name: 'WasteLabelStatus',
        component: () => import('@/modules/waste/views/homeNav/my/Labelstatus.vue')
      }
    ]
  }
]

export default wasteRoutes